import React, { useContext } from "react";
import { addMemberToProject } from "../../api/Api";
import { InitiativeContext } from "../../contexts/InitiativeContextProvider";
import { AddMemberModalUI } from "./AddMembersToOrganization";
import { useFormik } from "formik";
import { projectMemberRoleValidationSchema } from "../../utils/validations";
import { showToast } from "../../utils/toastUtils";


function AddNewMember({ show, handleClose, project_id }) {
  const { refresh } = useContext(InitiativeContext);

  const formik = useFormik({
    initialValues: {
      email: "",
      role: "",
    },
    validationSchema: projectMemberRoleValidationSchema,
    onSubmit: (values, { setSubmitting, setErrors }) => {
      const payload = {
        email: values.email,
        role: values.role,
      };
      
      addMemberToProject(project_id, payload).then((response) => {
        if (response.status === 200) {
          formik.resetForm();
          refresh();
          console.log("Project updated successfully");
          showToast(response?.message || "Member added successfully", "success");
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        setSubmitting(false);
        handleClose(); // Close modal on success
      });
    }
  })

  return (
    <AddMemberModalUI 
      show={show} 
      handleClose={handleClose} 
      formik={formik}
      bodyText="Enter your colleague's email address to add them to this project"
      roleOptions={[
        { id: "admin", name: "Admin" },
        { id: "contributor", name: "Contributor" },
      ]}
      buttonText="Add"
      title="Add Member"
    />
  );
}

export default AddNewMember;
